'use client'

import Link from 'next/link'
import { useSelectedLayoutSegment } from 'next/navigation'
import { useState } from 'react'
import { Icons } from '@/components/misc/icons'
import { buttonVariants } from '@/components/ui/button'
import { siteConfig } from '@/config/site'
import { cn } from '@/utils/cn'
import { MaxWidthWrapper } from './max-width-wrapper'

const navigation = {
  features: [
    { name: 'Automated Link Building', href: '/#features' },
    { name: 'Email Integration', href: '/#features' },
    { name: 'One-Click Link Prospecting', href: '/#features' },
    { name: 'Automated Contact Discovery', href: '/#features' },
  ],
  product: [
    { name: 'Blog', href: '/blog' },
    { name: 'Pricing', href: '/#pricing' },
    { name: 'Affiliate Program', href: '/blog/affiliate-program' },
    {
      name: 'Support',
      href: 'mailto:support@backlinkgpt.com?subject=Support Request',
    },
  ],
  compare: [],
  legal: [
    { name: 'Privacy', href: '/privacy' },
    { name: 'Terms', href: '/terms-of-use' },
  ],
  // tools: freeSeoTools.map(({ title, href }) => ({
  //   name: title,
  //   href,
  // })),
}

export function LandingLayoutFooter() {
  const selectedLayoutSegment = useSelectedLayoutSegment()

  if (selectedLayoutSegment === '(app)') return <></>

  return (
    <footer>
      <MaxWidthWrapper className="relative z-0 overflow-hidden border-t border-b-0 bg-background pt-16 pb-20 backdrop-blur-lg">
        <div className="mx-auto max-w-screen-2xl px-2 md:px-0 xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-6">
            <span className="sr-only">BacklinkGPT Logo</span>
            <Link href="/" className="flex items-center space-x-2">
              <Icons.logo className="size-8" />
              <span className="inline-block font-bold">{siteConfig.name}</span>
            </Link>
            <p className="max-w-xs text-sm">
              Automate Your Link-Building with AI-Personalized Outreach.
            </p>
            <p className="text-muted-foreground text-sm leading-5">
              © {new Date().getFullYear()} BacklinkGPT
            </p>
            <div className="flex items-center space-x-3">
              <a
                href="https://twitter.com/BacklinkGPT"
                target="_blank"
                rel="noreferrer"
                className={buttonVariants({
                  size: 'icon',
                  variant: 'outline',
                })}
              >
                <span className="sr-only">Twitter</span>
                <Icons.twitter className="h-4 w-4" />
              </a>
              <a
                href="https://www.linkedin.com/company/backlinkgpt"
                target="_blank"
                rel="noreferrer"
                className={buttonVariants({
                  size: 'icon',
                  variant: 'outline',
                })}
              >
                <span className="sr-only">Twitter</span>
                <Icons.linkedin className="h-4 w-4" />
              </a>
              <a
                href="https://github.com/feliche93"
                target="_blank"
                rel="noreferrer"
                className={buttonVariants({
                  size: 'icon',
                  variant: 'outline',
                })}
              >
                <span className="sr-only">Github</span>
                <Icons.gitHub className="h-4 w-4" />
              </a>
            </div>
            <StatusBadge />
          </div>
          <div className="mt-16 grid grid-cols-2 gap-4 xl:col-span-2 xl:mt-0">
            <div className="gap-6 md:grid md:grid-cols-2">
              <div>
                <h3 className="font-semibold text-sm">Features</h3>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation.features.map((item) => (
                    <li key={item.name}>
                      <Link
                        href={item.href}
                        className="text-muted-foreground text-sm hover:text-foreground"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="font-semibold text-sm">Product</h3>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation.product.map((item) => (
                    <li key={item.name}>
                      <Link
                        href={item.href}
                        className="text-muted-foreground text-sm hover:text-foreground"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="gap-6 md:grid md:grid-cols-2">
              <div className="flex flex-col space-y-8">
                {/* <div>
                  <h3 className="text-sm font-semibold">Compare</h3>
                  <ul role="list" className="mt-4 space-y-4">
                    {navigation.compare.map((item) => (
                      <li key={item.name}>
                        <Link
                          href={item.href}
                          className="text-sm text-muted-foreground hover:text-foreground"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div> */}
                <div>
                  <h3 className="font-semibold text-sm">Legal</h3>
                  <ul role="list" className="mt-4 space-y-4">
                    {navigation.legal.map((item) => (
                      <li key={item.name}>
                        <Link
                          href={item.href}
                          className="text-muted-foreground text-sm hover:text-foreground"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="mt-10 md:mt-0">
                {/* <h3 className="font-semibold text-sm">Free SEO Tools</h3>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation.tools.map((item) => {
                    if (!item.href) return null
                    return (
                      <li key={item.name}>
                        <Link
                          href={item.href}
                          className="text-muted-foreground text-sm hover:text-foreground"
                        >
                          {item.name}
                        </Link>
                      </li>
                    )
                  })}
                </ul> */}
              </div>
            </div>
          </div>
        </div>
      </MaxWidthWrapper>
    </footer>
  )
}

function StatusBadge() {
  // const { data } = useSWR<{
  //   ongoing_incidents: {
  //     name: string;
  //     current_worst_impact:
  //       | "degraded_performance"
  //       | "partial_outage"
  //       | "full_outage";
  //   }[];
  // }>("https://status.backlinkgpt.com/api/v1/summary", fetcher);

  const [color, setColor] = useState('bg-green-500')
  const [status, setStatus] = useState('All systems operational')

  // useEffect(() => {
  //   if (!data) return;
  //   const { ongoing_incidents } = data;
  //   if (ongoing_incidents.length > 0) {
  //     const { current_worst_impact, name } = ongoing_incidents[0];
  //     const color =
  //       current_worst_impact === "degraded_performance"
  //         ? "bg-yellow-500"
  //         : "bg-red-500";
  //     setStatus(name);
  //     setColor(color);
  //   } else {
  //     setStatus("All systems operational");
  //     setColor("bg-green-500");
  //   }
  // }, [data]);

  return (
    <div
      // href="https://status.backlinkgpt.com"
      // target="_blank"
      className="group flex max-w-fit items-center space-x-2 rounded-md border bg-card px-3 py-2 transition-colors hover:bg-card"
    >
      <div className="relative h-3 w-3">
        <div
          className={cn(
            'absolute inset-0 m-auto h-3 w-3 animate-ping items-center justify-center rounded-full group-hover:animate-none',
            color,
            status === 'Loading status...' && 'animate-none',
          )}
        />
        <div className={cn('absolute inset-0 z-10 m-auto h-3 w-3 rounded-full', color)} />
      </div>
      <p className="font-medium text-sm">{status}</p>
    </div>
  )
}
